/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { h600 } from '@atlaskit/theme/typography';
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var lightH600Styles = css(h600({
  theme: {
    mode: 'light'
  }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var darkH600Styles = css(h600({
  theme: {
    mode: 'dark'
  }
}));
var modalBodyStyles = css({
  padding: "var(--ds-space-500, 40px)".concat(" ", "var(--ds-space-250, 20px)"),
  textAlign: 'center'
});
var modalHeadingStyles = css({
  marginBottom: "var(--ds-space-100, 8px)",
  color: 'inherit'
});
var modalImageStyles = css({
  width: '100%',
  height: 'auto',
  borderTopLeftRadius: "var(--ds-border-radius, 3px)",
  borderTopRightRadius: "var(--ds-border-radius, 3px)",
  // TODO: Use new breakpoints
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
  '@media (min-width: 320px) and (max-width: 480px)': {
    borderRadius: 0
  }
});
var modalActionContainerStyles = css({
  display: 'flex',
  padding: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-500, 40px)", " 36px"),
  justifyContent: 'center',
  flexDirection: 'row',
  flexFlow: 'wrap'
});
var modalActionContainerReversedStyles = css({
  flexDirection: 'row-reverse'
});
var modalActionItemStyles = css({
  margin: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-050, 4px)")
});

/**
 * __Modal body__
 *
 * @internal
 */
export var ModalBody = function ModalBody(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: modalBodyStyles
  }, children);
};

/**
 * __Modal heading__
 *
 * @internal
 */
export var ModalHeading = function ModalHeading(_ref2) {
  var children = _ref2.children;
  var _useGlobalTheme = useGlobalTheme(),
    mode = _useGlobalTheme.mode;
  return jsx("h4", {
    css: [mode === 'light' ? lightH600Styles : darkH600Styles, modalHeadingStyles]
  }, children);
};

/**
 * __Modal image__
 *
 * @internal
 */
export var ModalImage = function ModalImage(_ref3) {
  var alt = _ref3.alt,
    src = _ref3.src;
  return jsx("img", {
    css: modalImageStyles,
    alt: alt,
    src: src
  });
};

/**
 * __Modal action container__
 *
 * @internal
 */
export var ModalActionContainer = function ModalActionContainer(_ref4) {
  var children = _ref4.children,
    shouldReverseButtonOrder = _ref4.shouldReverseButtonOrder;
  return jsx("div", {
    css: [modalActionContainerStyles, shouldReverseButtonOrder && modalActionContainerReversedStyles]
  }, children);
};

/**
 * __Modal action item__
 *
 * @internal
 */
export var ModalActionItem = function ModalActionItem(_ref5) {
  var children = _ref5.children;
  return jsx("div", {
    css: modalActionItemStyles
  }, children);
};